import { Params } from "@/types/utils";
import { triggerFileDownload } from "@/utils/helpers";
import { log } from "@/utils/logger";
import { useParams } from "react-router-dom";
import { useModal } from "../context";
import api from "@/config/api";

interface DownloadCard {
    cid: string;
    pid: string;
    eid: string;
}

const useDownloadCard = () => {
    const setLoading = useModal(state => state.setLoading);
    const { oid, bid } = useParams<Params>();

    const onDownloadCard = async ({ cid, pid, eid }: DownloadCard) => {
        try {
            setLoading(true);
            const data = await api.post<{ blob: Blob; filename: string }>(
                `/organizations/${oid}/brands/${bid}/products/${pid}/card`,
                { data: { eid, cid } },
            );

            const fileName = data.filename;
            if (!fileName) throw new Error("Failed to receive file name");

            const url = URL.createObjectURL(data.blob);
            triggerFileDownload(url, fileName);
            URL.revokeObjectURL(url);
        } catch (e) {
            log.error(e, "onDownloadCard");
        } finally {
            setLoading(false);
        }
    };

    return onDownloadCard;
};

export { useDownloadCard };
